module.exports = __webpack_public_path__ + "img/icon_bianji.beaeabe7.svg";